import { LinksList } from "../components";

export const mockedMyAccountDropdownLinksList: LinksList = [
  {
    title: "Overview",
    link: { href: "/mock-url/overvew" },
  },
  {
    title: "Payment",
    link: { href: "/mock-url/payment" },
  },
  {
    title: "Delivery",
    link: { href: "/mock-url/delivery" },
  },
  {
    title: "Communication",
    link: { href: "/mock-url/communication" },
  },
  {
    title: "Loyalty",
    link: { href: "/mock-url/loyalty" },
  },
  {
    title: "Interests",
    link: { href: "/mock-url/interests" },
  },
  {
    title: "My Store",
    link: { href: "/mock-url/my-store" },
  },
  {
    title: "Account Details",
    link: { href: "/mock-url/account-details" },
  },
  {
    title: "Help",
    link: { href: "/mock-url/help" },
  },
];
